import { render, staticRenderFns } from "./VeHrJingtieForm.vue?vue&type=template&id=28bad36a"
import script from "./VeHrJingtieForm.vue?vue&type=script&lang=js"
export * from "./VeHrJingtieForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports